import React from 'react';
import styled from 'styled-components/macro';

import { ReactComponent as NotifyIcon } from 'icons/icon-notify.svg';

const MessageBlock = styled.article`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  padding: ${({ theme }): string => theme.spacing.large};
  margin: 0.5em;
  background: white;
  position: relative;

  @media screen and (min-width: 40em) {
    margin: ${({ theme }): string => `${theme.spacing.medium} 0`};
  }
`;

export const MediaIcon = styled('div')`
  margin-right: ${({ theme }): string => `${theme.spacing.medium}`};
  color: ${({ theme }): string => theme.CasperGrey};
  line-height: 1;
  flex-shrink: 0;
`;

export const MediaContent = styled('div')<any>`
  color: ${({ theme }): string => theme.DeepBlue};
  line-height: 1.4;
  flex: ${({ isEditMode }): string => (isEditMode ? '1 1 auto' : ' 1 1 0%')};

  > p {
    margin: 0;
  }
`;

const Message = ({
  children,
  className,
}: {
  children: any;
  className?: any;
}): any => (
  <MessageBlock className={className} data-pw="MessageBlock">
    <MediaIcon>
      <NotifyIcon />
    </MediaIcon>
    <MediaContent>{children}</MediaContent>
  </MessageBlock>
);

export const MessageWithSmallMargin = styled(Message)`
  &:first-child {
    margin: ${({ theme }): string => `${theme.spacing.medium} 0`};
  }
`;

export default Message;
